import React, { useEffect, useState } from "react";
import AddUser from "./AddUserAdmin";
import EditSupervisor from "./EditSupervisor";
import DeleteItem from "./DeleteItem";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {
    Box,
    Typography,
    Button,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    InputBase,
    TableBody,
    IconButton,
    Pagination,
    Select,
    MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from "react-redux";
import {
    UserMaintenanceContainer,
    PageContainer,
    HeaderBar,
    RightSection,
    AddButton,
    SearchWrapper,
    Title,
    StyledTableWrapper,
    StyledTableCellHead,
    StyledTableCellBody,
    FooterRow,
} from "./UserMaintenanceAdmin.styles";
import {
    submitUserRoles,
    downloadUserRoles,
    getUserMaintanenceData,
} from "../../store/UserMaintanence";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5),
    paddingLeft: theme.spacing(15),
    paddingRight: theme.spacing(15),
  }
}));

const ColorButton = styled(Button)(({ theme }) => ({
    borderRadius: "0px",
}));

const UserMaintenance = () => {
    const dispatch = useDispatch();
    const [isAlertSec, setisAlertSec] = React.useState(false);
    const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
    const userMaintenanceTableError = useSelector((state) => state.userRoles.error);
    const [openEdit, setOpenEdit] = useState(false);
    const [supervisorRowId, setSupervisorRowId] = useState("");
    const [entId, setEntId] = useState("");
    const [openAddUser, setOpenAddUser] = useState(false);
    const [boolChecked, setBoolChecked] = useState(false);
    const [boolCheckedDelete, setBoolCheckedDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteEntId, setDeleteEntId] = useState("");
    const [searchVal, setSearchVal] = useState("");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    useEffect(() => {
        dispatch(getUserMaintanenceData());
        setBoolChecked(false);
    }, [isAlertSec, boolChecked, boolCheckedDelete]);

    useEffect(() => {
        setFilteredData(userData);
    }, [userData]);

    useEffect(() => {
        setFilteredData(
            userData?.filter((item) =>
            item?.Enterprise_ID
                ?.toLowerCase()
                .includes(searchVal.toLowerCase())
            )
        );
    }, [searchVal]);

    useEffect(() => {
        setCheckedValues(
            filteredData?.map((item) => {
                const { Enterprise_ID, Supervisor, sno, ...rest } = item;

                const Admin = rest.Admin === "yes";
                const isActive = rest.isActive === "yes";

                return {
                    Enterprise_ID,
                    Supervisor,
                    sno,
                    Admin,
                    isActive,
                    disabledAdmin: !isActive,
                    disabledIsActive: !Admin,
                };
            })
        );
    }, [filteredData]);

    const handleCheckboxChange = (enterpriseId, key) => {
        setCheckedValues((prev) =>
            prev.map((item) => {
                if (item.Enterprise_ID !== enterpriseId) return item;
                let updated = { ...item };
                if (key === "Admin") {
                    const newVal = !item.Admin;
                    updated.Admin = newVal;
                    updated.disabledIsActive = !newVal;
                }
                if (key === "isActive") {
                    const newVal = !item.isActive;
                    updated.isActive = newVal;
                    updated.disabledAdmin = !newVal;
                }

                return updated;
            })
        );
    };

    const handleOpenEdit = (supervisorName, item) => {
        setOpenEdit(true);
        setSupervisorRowId(supervisorName);
        setEntId(item?.Enterprise_ID);
    };

    const handleSubmit = () => {
        const mappedArray = checkedValues.map((item) => ({
            Enterprise_ID: item.Enterprise_ID,
            Supervisor: item.Supervisor,
            Admin: item.Admin ? "yes" : "no",
            isActive: item.isActive ? "yes" : "no",
        }));

        dispatch(submitUserRoles(mappedArray));
        setisAlertSec(true);
    };

    const handleDelete = (enterpriseID, item) => {
        setOpenDelete(true);
        setDeleteEntId(enterpriseID);
    };
    const handleClose = () => {
        setisAlertSec(false);
    };

    const paginatedData = filteredData?.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    return (
        <UserMaintenanceContainer>
            {userMaintenanceTableError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
            <PageContainer>
                <HeaderBar>
                    <Title>Admin User Maintenance</Title>

                    <RightSection>
                        <SearchWrapper>
                            <SearchIcon className="search-icon" />
                            <InputBase
                                placeholder="Search by Enterprise ID"
                                value={searchVal}
                                onChange={(e) => setSearchVal(e.target.value)}
                                fullWidth
                            />
                        </SearchWrapper>
                        <AddButton onClick={() => setOpenAddUser(true)}>+ Add User</AddButton>
                    </RightSection>
                </HeaderBar>

                <StyledTableWrapper>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHead>Serial no.</StyledTableCellHead>
                                <StyledTableCellHead>
                                Enterprise ID
                                <img
                                    src={
                                    process.env.PUBLIC_URL +
                                    "/images/UserMaintenance/arrow-icon.png"
                                    }
                                    style={{ width: "10px", marginLeft: "10px" }}
                                />
                                </StyledTableCellHead>
                                <StyledTableCellHead>
                                Supervisor
                                <img
                                    src={
                                    process.env.PUBLIC_URL +
                                    "/images/UserMaintenance/arrow-icon.png"
                                    }
                                    style={{ width: "10px", marginLeft: "10px" }}
                                />
                                </StyledTableCellHead>
                                <StyledTableCellHead>Admin</StyledTableCellHead>
                                <StyledTableCellHead>isActive</StyledTableCellHead>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {paginatedData?.map((row, index) => {
                                const rowState = checkedValues.find(
                                    (i) => i.Enterprise_ID === row.Enterprise_ID
                                );

                                const showDelete =
                                    !rowState?.Admin ||
                                    !rowState?.isActive ||
                                    rowState?.disabledAdmin ||
                                    rowState?.disabledIsActive;
                            return (
                                <TableRow key={index}>
                                    <StyledTableCellBody>{row.sno}</StyledTableCellBody>

                                    <StyledTableCellBody>
                                        {row.Enterprise_ID}
                                    </StyledTableCellBody>

                                    <StyledTableCellBody>
                                        {row.Supervisor}
                                        <IconButton size="small">
                                            <img
                                                src={
                                                process.env.PUBLIC_URL +
                                                "/images/UserMaintenance/edit-icon.png"
                                                }
                                                style={{ width: "15px", marginBottom: "5px", marginLeft: "10px" }}
                                                onClick={() => handleOpenEdit(row["Supervisor"], row)}
                                            />
                                        </IconButton>
                                    </StyledTableCellBody>

                                    <StyledTableCellBody className="checkbox-cell">
                                        <Checkbox
                                            checked={
                                                checkedValues.find(i => i.Enterprise_ID === row.Enterprise_ID)?.Admin || false
                                            }
                                            disabled={
                                                checkedValues.find(i => i.Enterprise_ID === row.Enterprise_ID)?.disabledAdmin || false
                                            }
                                            onChange={() =>
                                                handleCheckboxChange(row.Enterprise_ID, "Admin")
                                            }
                                            sx={{
                                                color: "#000",
                                                "&.Mui-checked": {
                                                    color: "#000",
                                                },
                                                "&.Mui-disabled": {
                                                    color: "#CFCFCF",
                                                },
                                                "&.Mui-disabled.Mui-checked": {
                                                    color: "#CFCFCF",
                                                }
                                            }}
                                        />
                                    </StyledTableCellBody>

                                    <StyledTableCellBody className="checkbox-cell">
                                        <Checkbox
                                            checked={
                                                checkedValues.find(i => i.Enterprise_ID === row.Enterprise_ID)?.isActive || false
                                            }
                                            disabled={
                                                checkedValues.find(i => i.Enterprise_ID === row.Enterprise_ID)?.disabledIsActive || false
                                            }
                                            onChange={() =>
                                                handleCheckboxChange(row.Enterprise_ID, "isActive")
                                            }
                                            sx={{
                                                color: "#000",
                                                "&.Mui-checked": {
                                                    color: "#000",
                                                },
                                                "&.Mui-disabled": {
                                                    color: "#CFCFCF",
                                                },
                                                "&.Mui-disabled.Mui-checked": {
                                                    color: "#CFCFCF",
                                                }
                                            }}
                                        />
                                        {/* {showDelete && (
                                            <img
                                                src={process.env.PUBLIC_URL + "/images/UserMaintenance/delete_icon.jpeg"}
                                                onClick={() => handleDelete(row["Enterprise_ID"], row)}
                                                style={{ width: "25px", marginBottom: "-5px", cursor: "pointer"}}
                                            />
                                        )} */}
                                    </StyledTableCellBody>
                                </TableRow>
                            );
                        })}
                        </TableBody>
                    </Table>
                </StyledTableWrapper>

                <FooterRow>
                    <Box display="flex" alignItems="center" gap={2}>
                        <Pagination
                            count={Math.ceil(filteredData.length / rowsPerPage)}
                            page={page}
                            onChange={(e, val) => setPage(val)}
                            size="small"
                            sx= {{
                                "& .MuiPaginationItem-root": { 
                                    borderRadius: 0,
                                    fontSize: "14px",
                                    color: "#000000",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "transparent !important", 
                                    color: "#000000", 
                                    fontWeight: 600, 
                                    position: "relative",
                                },
                                "& .Mui-selected::after": {
                                    content: '""',
                                    position: "absolute",
                                    left: "1px",
                                    right: "1px",
                                    bottom: "0px",
                                    height: "2px",
                                    backgroundColor: "#A100FF",
                                },
                                "& .MuiPaginationItem-root:hover": { 
                                    backgroundColor: "transparent",
                                },
                            }}
                        />

                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">Items per page</Typography>
                            <Select
                                size="small"
                                value={rowsPerPage}
                                onChange={(e) => setRowsPerPage(e.target.value)}
                                IconComponent={KeyboardArrowDownIcon}
                                sx=
                                    {{
                                    borderRadius: "0px",
                                    "& .MuiOutlinedInput-notchedOutline": { 
                                        borderRadius: "0px",
                                        borderColor: "#AFAFAF",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#000",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#000",
                                    },
                                    "& .MuiSelect-select": {
                                        padding: "6px 28px 6px 10px",
                                        fontSize: "14px",
                                    },
                                    "& .MuiSelect-icon": {
                                        color: "#6F6F6F",
                                        right: "6px",
                                        width: "20px",
                                    },
                                }}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                            </Select>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2}>
                        <Button
                            variant="contained"
                            className="submit-btn"
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>

                        <Button
                            variant="contained"
                            className="download-btn"
                            onClick={() => dispatch(downloadUserRoles())}
                        >
                            Download
                        </Button>
                    </Box>
                </FooterRow>
            </PageContainer>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={isAlertSec}
                PaperProps={{ sx: { width: "350px", maxWidth: "350px", borderTop: "2px solid #A100FF", borderRadius: "0px" } }}
            >
                <DialogContent sx={{ padding: "0px !important"}}>
                    <Typography sx={{ fontSize: "15px", fontWeight: "600", color: "#000000", padding: "20px 30px", textAlign: "center"}}>
                        Your changes are saved
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: "8px 10px !important", backgroundColor: "#F1F1EF"}}>
                    <ColorButton
                        variant="contained"
                        className="cancel-button"
                        size="small"
                        sx={{ backgroundColor: "#000000",
                            border: "1px solid #000000",
                            padding: "5px 45px",
                            color: "#fff",
                            borderRadius: 0,
                            height: "30px",
                            "&:hover": { backgroundColor: "#000000" }
                        }}
                        autoFocus
                        onClick={handleClose}
                    >
                        Ok
                    </ColorButton>
                </DialogActions>
            </BootstrapDialog>
            <AddUser
                open={openAddUser}
                onClose={() => setOpenAddUser(false)}
            />
            <EditSupervisor
                openEdit={openEdit}
                setOpenEdit={setOpenEdit}
                supervisorRowId={supervisorRowId}
                entId={entId}
                setBoolChecked={setBoolChecked}
                />
            <DeleteItem
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
                deleteEntId={deleteEntId}
                setBoolCheckedDelete={setBoolCheckedDelete}
            />
        </UserMaintenanceContainer>
    );
};

export default UserMaintenance;